<template>
  <div>
    <v-app-bar text color="red-darken-3" class="pt-1">
      <!-------------------------------------------TITLE------------------------------------------->
      <v-app-bar-title class="hidden-xs-only">
        {{ $t("leko_employees.approve_users.label") }}
      </v-app-bar-title>
      <!------------------------------------------------------------------------------------------->
      <v-divider class="mx-5 hidden-xs-only" inset vertical />
      <!------------------------------------------------------------------------------------------->
      <v-text-field
        v-model="search"
        :label="$t('leko_employees.approve_users.search')"
        text
        variant="solo"
        color="red-darken-1"
        append-inner-icon="mdi-magnify"
        single-line
        hide-details
        @keyup.enter="searchMethod()"
        @click:append-inner="searchMethod()"
      />

      <!--ADVANCED MD-AND-UP-->
      <v-btn
        class="ml-1 mr-5 hidden-sm-and-down"
        variant="flat"
        color="grey-darken-4"
        small
        @click="advancedSearch = !advancedSearch"
      >
        <v-icon start>
          {{
            advancedSearch
              ? "mdi-checkbox-marked-outline"
              : "mdi-checkbox-blank-outline"
          }}
        </v-icon>
        {{ $t("leko_employees.approve_users.advanced") }}
      </v-btn>

      <v-spacer class="hidden-sm-and-down" />
      <!------------------------------------------------------------------------------------------->
    </v-app-bar>
    <div class="redColor">
      <v-row class="justify-center align-center">
        <!--ADVANCED SM-AND-DOWN-->
        <v-btn
          class="hidden-md-and-up ml-2"
          variant="flat"
          small
          @click="advancedSearch = !advancedSearch"
        >
          <v-icon start>
            {{
              advancedSearch
                ? "mdi-checkbox-marked-outline"
                : "mdi-checkbox-blank-outline"
            }}
          </v-icon>
          {{ $t("leko_employees.approve_users.advanced") }}
        </v-btn>
      </v-row>
      <!--------------------------------------ADVANCED SEARCH-------------------------------------->
      <div v-if="advancedSearch">
        <v-row row color="red-darken-3" class="pb-2 pl-3 pr-3 mt-3" wrap>
          <v-col xs="12" md="12" lg="12" class="pb-0">
            <v-select
              v-model="advancedSearchItems.status"
              :items="statusItems"
              item-title="title"
              item-value="value"
              variant="solo"
              text
              chips
              closable-chips
              multiple
              color="red-darken-2"
              class="ml-2 mr-2 mt-2"
              persistent-hit
            />
          </v-col>
          <v-col xs="12" md="12" lg="12" class="pt-0">
            <v-row class="justify-center pb-3">
              <v-btn
                dark
                color="grey-darken-4"
                class="mx-1"
                @click="clearSearchFields"
              >
                {{ $t("leko_employees.approve_users.clear") }}
                <v-icon end> mdi-notification-clear-all </v-icon>
              </v-btn>
              <v-btn
                dark
                color="grey-darken-4"
                class="mx-1"
                @click="searchMethod"
              >
                {{ $t("leko_employees.approve_users.search") }}
                <v-icon end> mdi-magnify </v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <!------------------------------------------------------------------------------------------->
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    advancedSearch: false,
    search: "",
    advancedSearchItems: {
      status: ["Approved", "Waiting Approval", "Refused"],
    },
    statusItems: [
      { title: "Approved", value: "Approved" },
      { title: "Waiting Approval", value: "Waiting Approval" },
      { title: "Refused", value: "Refused" },
    ],
  }),
  watch: {
    search(value) {
      if (value.length < 1 && this.advancedSearch === false) {
        this.$emit("clear-search");
      }
    },
  },
  mounted() {
    this.getLocale();
  },
  methods: {
    getLocale() {
      this.statusItems[0].title = this.$t(
        "leko_employees.approve_users.status.approved",
      );
      this.statusItems[1].title = this.$t(
        "leko_employees.approve_users.status.waiting_approval",
      );
      this.statusItems[2].title = this.$t(
        "leko_employees.approve_users.status.refused",
      );
    },
    searchMethod() {
      if (this.advancedSearch) {
        // ADVANCED SEARCH
        this.$emit("adv-search", {
          searchField: this.search,
          advancedSearchFields: this.advancedSearchItems,
        });
      } else if (this.search.length > 0) {
        // REGULAR SEARCH
        this.$emit("search", { searchField: this.search });
      }
    },
    clearSearchFields() {
      this.search = "";
      this.advancedSearchItems = {
        status: ["Approved", "Waiting Approval", "Refused"],
      };
      this.$emit("clear-search");
    },
  },
};
</script>
